// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;My heart tells of your word, &#145;Seek my face.&#146;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Your face, Lord, will I seek.<br> </p> </div></div>";
// Exports
module.exports = code;